import React from "react";
import LoadingSpinner from "../../../../../../components/LoadingSpinner";


export default function OnAdding(){
  return <div className="on-adding alert alert-info text-center w-100 mb-0"><LoadingSpinner /></div>;
}